//@flow
import moment from 'moment-timezone';

import { PjpMetricGraph } from 'common/models/internal/PjpMetricGraph';

export default class PjpMetricCardDecider {
    static isGroupByVariable(
        graph: PjpMetricGraph,
        groupBy: string,
        filters: Object
    ): boolean {
        return groupBy.isPrimaryDateField && !graph.graphInfo.isSingleDayGraph
            ? PjpMetricCardDecider.countDateDimensions(filters) > 1
            : true;
    }

    static countDateDimensions(filters: Object) {
        const { from, to } = filters.dateRange;
        return moment(to).diff(moment(from), 'days') + 1;
    }
}
